/* eslint-disable @typescript-eslint/no-explicit-any */
import {Component, Vue, Watch} from "vue-property-decorator";

import {
    getCompanyList,
    setFinanceContractTemplateById, getFinanceContractTemplateById,
    getProjectAllSouCoursePriceList, setFinanceContractTemplate
} from '@/api/financial-center'

import {menuBtn} from '@/utils/menu_level2_button'

import {delNullProperty} from "@/utils";

import E from "wangeditor"
import commonData from "@/utils/commonData";

@Component({})
export default class NewContractTemplate extends Vue {
    limit = 20
    tableKey = Math.random()

    formData = {
        detail: '',
        souCourseTypeId: '',
        souCoursePrice: '',
        dissertationType: '',
        companyName: '',
        name: '',
    }

    companyList = []

    disabledButton = false
    saveDraftDialogShow = false
    //
    // isDraft = '0'
    // draftId: number = null // 草稿id

    contractTemplateId = null
    isReplace = null


    previewName = ''
    previewVisible = false
    previewPath = ''
    directorUserId = ''


    editor: any = null
    editor2: any = null
    typeList = commonData.projectTypeArray
    souCoursePriceList = []
    loading = false
    formRule = {
        souCourseTypeId : [{required: true, message: '请选择项目类型', trigger: 'change'}],
        souCoursePrice : [{required: true, message: '请选择项目价格', trigger: 'change'}],
        dissertationType : [{required: true, message: '请选择论文服务类型', trigger: 'change'}],
        companyName : [{required: true, message: '请选择所属公司', trigger: 'change'}],
        name : [{required: true, message: '请填写模版名称', trigger: ['change','blur']}],
    }
    contractTemplateOldId = null
    conditionTags = [
        '优惠金额', '项目价格', '备注', '收款账户'
    ]


    created() {
        if (this.$route.query.contractTemplateId) {
            this.contractTemplateId = Number(this.$route.query.contractTemplateId)
            this.getFinanceContractTemplateById(this.contractTemplateId)
        }
        if (this.$route.query.contractTemplateOldId) {
            this.contractTemplateOldId = Number(this.$route.query.contractTemplateOldId)
            this.getFinanceContractTemplateById(this.contractTemplateOldId)
        }

        this.getCompanyList()

    }

    menuBtn = menuBtn

    mounted() {
        this.initEditor()
    }

    // 初始化富文本编辑器
    initEditor() {
        this.editor = new E('#div1')
        this.editor2 = new E('#div2')
        this.editor.config.height = 200
        this.editor2.config.height = 200
        this.editor.config.excludeMenus = [
            'fontName',
            'foreColor',
            'backColor',
            'link',
            'code',
            'splitLine',
            'undo',
            'redo'
        ]
        this.editor2.config.excludeMenus = [
            'fontName',
            'foreColor',
            'backColor',
            'link',
            'code',
            'splitLine',
            'undo',
            'redo'
        ]

        this.editor.config.uploadImgShowBase64 = true // 使用 base64 保存图片
        this.editor2.config.uploadImgShowBase64 = true // 使用 base64 保存图片
        // 隐藏“网络图片”tab
        this.editor.config.showLinkImg = false
        this.editor2.config.showLinkImg = false

        // 创建编辑器
        this.editor.create()
        this.editor2.create()

        // 修改提示信息
        document.getElementsByClassName('placeholder')[0].innerHTML = "请输入正文内容"
        document.getElementsByClassName('placeholder')[1].innerHTML = "请输入附件内容"

        this.editor.txt.html()
        this.editor2.txt.html()

     }

    async changeSouCourseType(val) {
        this.getSouCoursePriceList(val)
    }

    async getSouCoursePriceList(val) {
        const data: any = await getProjectAllSouCoursePriceList({
            souCourseTypeId: val
        })
        this.souCoursePriceList = data.souCoursePriceList
    }

    handleFocusSouCoursePrice() {
        if (!this.formData.souCourseTypeId) {
            this.$message.error('请先选择项目类型')
            return
        }
        this.getSouCoursePriceList(this.formData.souCourseTypeId)
    }

    async getFinanceContractTemplateById(id) {
        this.isReplace = true
        this.loading = true
        await getFinanceContractTemplateById(delNullProperty({
            id: id,
        })).then((data: any)=>{

            const {financeContractTemplate} = data
            this.formData = financeContractTemplate
            if (this.contractTemplateOldId) {
                this.$set(this.formData, 'companyName', '')
            }

        const a = this.formData.detail.indexOf('</aside>')
        const b = this.formData.detail.lastIndexOf('</main>')
        const c = this.formData.detail.lastIndexOf('</article>')

            const editorHtml = this.formData.detail.slice(a, b).substring(8).replace('<aside style="font-family:SourceHanSans;">', '')
            editorHtml.replace('</aside>', '')
            //     恢复Tag标签
            let str = editorHtml.replace('{{优惠金额}}', '<input type="button" value="优惠金额" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')
            str = str.replace('{{项目金额}}', '<input type="button" value="项目价格" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')
            str = str.replace('{{备注}}', '<input type="button" value="备注" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')
            str = str.replace('{{收款账户}}','<input type="button" value="收款账户" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>')

            this.editor.txt.html(str)
            const editorHtml1 = this.formData.detail.substring(c).substring(10).replace('<section style="font-family:SourceHanSans;page-break-before: always;">', '')
            editorHtml.replace('</section>', '')
            this.editor2.txt.html(editorHtml1)
            this.loading = false
        }).catch(err => {
            this.loading = false
        })
    }





    /*保存*/
    clickSubmintButton() {
        // 校验
        const code1 =  document.getElementById('mainTable').innerHTML
        const code5=  document.getElementById('containerMain').innerHTML

        /*将合同模板里的tag改成需要的字符*/
        let str = this.editor.txt.html().replace(/<input[^>]*value="优惠金额"[^>]*\/>/g, '{{优惠金额}}')
        str = str.replace(/<input[^>]*value="项目价格"[^>]*\/>/g, '{{项目金额}}')
        str = str.replace(/<input[^>]*value="备注"[^>]*\/>/g, '{{备注}}')
        str = str.replace(/<input[^>]*value="收款账户"[^>]*\/>/g, '{{收款账户}}')

        let code2 = '<aside style="font-family:SourceHanSans;">'+str+'</aside>'
        const code3 =  document.getElementById('footerTable').innerHTML
        let code4 = '<section style="font-family:SourceHanSans;page-break-before: always;">'+this.editor2.txt.html()+'</section>'
        code2 = code2.replace(/<table/g, '<table border="1" style="border-collapse:collapse;"');
        code4 = code4.replace(/<table/g, '<table border="1" style="border-collapse:collapse;"')
        this.formData.detail = '<div style="width: 1000px; padding: 0 60px;">'+ code1 + code5+ code2 + code3 + (this.editor2.txt.html() ? code4: '') + '</div>';


        (this.$refs['formRef'] as any).validate((valid) => {
            if (valid) {
                
                const obj = {
                    detail: this.formData.detail,
                    souCourseTypeId: this.formData.souCourseTypeId,
                    souCoursePrice: this.formData.souCoursePrice,
                    dissertationType: this.formData.dissertationType,
                    companyNameList: this.formData.companyName,
                    name: this.formData.name,

                };
                if (!this.formData.souCourseTypeId) {
                    this.$message.error('请选择项目类型')
                    return;
                }
                // 2024-09-20 项目类型为国内1v1 国外1v1 竞赛1v1的时候 价格不必填
                if (!this.formData.souCoursePrice && (this.formData.souCourseTypeId != '2' && this.formData.souCourseTypeId != '3' && this.formData.souCourseTypeId != '40')) {
                    this.$message.error('请选择项目价格')
                    return;
                }
                if (!this.formData.dissertationType) {
                    this.$message.error('请选择论文服务类型')
                    return;
                }
                if (this.formData.companyName.length == 0) {
                    this.$message.error('请选择所属公司')
                    return;
                }
                if (!this.formData.name) {
                    this.$message.error('请填写模板名称')
                    return;
                }
                if (!this.formData.detail) {
                    this.$message.error('请上传合同')
                    return;
                }


                this.disabledButton = true;
                this.loading = true
                setFinanceContractTemplate(delNullProperty(obj)).then((data) => {
                    this.$message.success(`新建成功`)
                    this.saveDraftDialogShow = false
                    this.loading = false
                    setTimeout(() => {
                        this.closePage()
                    }, 1500)
                }).catch((err: Error) => {
                    if (err) {
                        this.disabledButton = false
                        this.loading = false
                    }
                })
            }
        })
    }


    /*编辑保存*/
    clickEditSubmitButton() {

        const code1 = document.getElementById('mainTable').innerHTML
        const code5 = document.getElementById('containerMain').innerHTML
        // const code2 = this.editor.txt.html()

        /*将合同模板里的tag改成需要的字符*/
        let str = this.editor.txt.html().replace(/<input[^>]*value="优惠金额"[^>]*\/>/g, '{{优惠金额}}')
        str = str.replace(/<input[^>]*value="项目价格"[^>]*\/>/g, '{{项目金额}}')
        str = str.replace(/<input[^>]*value="备注"[^>]*\/>/g, '{{备注}}')
        str = str.replace(/<input[^>]*value="收款账户"[^>]*\/>/g, '{{收款账户}}')

        let code2 = '<aside style="font-family:SourceHanSans;">' + str + '</aside>'
        const code3 = document.getElementById('footerTable').innerHTML
        let code4 = '<section style="font-family:SourceHanSans;page-break-before: always;">' + this.editor2.txt.html() + '</section>' // page-break-before: always;始终在元素之前进行分页
        code2 = code2.replace(/<table/g, '<table border="1" style="border-collapse:collapse;"');
        code4 = code4.replace(/<table/g, '<table border="1" style="border-collapse:collapse;"')
        this.formData.detail = '<div style="width: 1000px; padding: 0 60px;">' + code1 + code5 + code2 + code3 + (this.editor2.txt.html() ? code4: '') + '</div>'


        const obj = {
            detail: this.formData.detail,
            souCourseTypeId: this.formData.souCourseTypeId,
            souCoursePrice: this.formData.souCoursePrice,
            dissertationType: this.formData.dissertationType,
            companyName: this.formData.companyName,
            name: this.formData.name,
            id: this.contractTemplateId,
        };
        if (!this.formData.souCourseTypeId) {
            this.$message.error('请选择项目类型')
            return;
        }
        // 2024-09-20 项目类型为国内1v1 国外1v1 竞赛1v1的时候 价格不必填
        if (!this.formData.souCoursePrice && (this.formData.souCourseTypeId != '2' && this.formData.souCourseTypeId != '3' && this.formData.souCourseTypeId != '40')) {
            this.$message.error('请选择项目价格')
            return;
        }
        if (!this.formData.dissertationType) {
            this.$message.error('请选择论文服务类型')
            return;
        }
        if (!this.formData.companyName) {
            this.$message.error('请选择所属公司')
            return;
        }
        if (!this.formData.name) {
            this.$message.error('请填写模板名称')
            return;
        }
        if (!this.formData.detail) {
            this.$message.error('请上传合同')
            return;
        }
        this.disabledButton = true
        /*编辑 项目价格可置空*/
        for (const key in obj) {
            if ((!obj[key] || obj[key].length === 0) && key !== 'souCoursePrice') {
                delete obj[key]
            }
        }
        setFinanceContractTemplateById(obj).then(res => {
            this.$message.success('保存成功，页面即将关闭')
            setTimeout(() => {
                this.closePage()
            }, 1500)
        }).catch(err => {
            this.disabledButton = false
        })
    }


    closePage() {
        window.close()
    }


    // 所属公司列表
    async getCompanyList() {
        const data: any = await getCompanyList()
        this.companyList = data.companyList
    }


    handleAppendTagToEditor(item) {
        const str = `<input type="button" value="${item}" style="border-width: 1px; border-style: solid; border-color: rgb(217, 236, 255); border-radius: 5px; padding-right: 5px; padding-left: 5px; background: rgb(237, 245, 255); color: rgb(70, 159, 255); height: 24px; line-height: 24px;"/>`
        // 在光标处插入文本
        /*如果从来没有被插入过则添加*/
        if (this.editor.txt.html().indexOf(str) === -1) {
            this.editor.cmd.do('insertHTML', `<input type="button" value="${item}"  style="display: inline-block;
            border: 1px solid #d9ecff;
            border-radius: 5px;
            padding-right: 5px; 
            padding-left: 5px;
            background: #edf5ff;
            color: #469fff;
            height: 24px;
            line-height: 24px;
            margin: 0; " />&nbsp;&nbsp;`)
        } else {
            this.$message.warning('该Tag已经被添加过')
            return
        }
    }

}
